import React from 'react';

// Helper function to get abbreviated month name
const getAbbreviatedMonthName = (monthIndex) => {
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  return monthNames[monthIndex];
};

// Helper function to get day with ordinal suffix (1st, 2nd, 3rd, etc.)
const getDayWithOrdinal = (day) => {
  if (day > 3 && day < 21) return `${day}th`; 
  switch (day % 10) {
    case 1: return `${day}st`;
    case 2: return `${day}nd`;
    case 3: return `${day}rd`;
    default: return `${day}th`;
  }
};

const SimpleDateDisplay = ({ dateString }) => {
  // 1. Handle empty input
  if (!dateString) {
    return <span>No Date Provided</span>;
  }

  // 2. Parse the DD-MM-YYYY string
  const parts = dateString.split('-');
  
  if (parts.length !== 3) {
    return <span>Invalid Date Format: {dateString}</span>;
  }

  // Map parts to readable variables
  // Expected input: "31-12-2025" -> day=31, month=12, year=2025
  const dayNum = parseInt(parts[0], 10);
  const monthNum = parseInt(parts[1], 10);
  const yearNum = parseInt(parts[2], 10);

  // 3. Create the Date object
  // Note: JavaScript months are 0-indexed (0 = Jan, 11 = Dec), 
  // so we subtract 1 from our month number.
  const dateObject = new Date(yearNum, monthNum - 1, dayNum);

  // 4. Validate the resulting date
  if (isNaN(dateObject.getTime())) {
    return <span>Error Parsing Date: {dateString}</span>;
  }

  // 5. Format the output
  const dayFormatted = getDayWithOrdinal(dateObject.getDate());
  const monthAbbr = getAbbreviatedMonthName(dateObject.getMonth());
  const year = dateObject.getFullYear();

  // Result example: 31st Dec | 2025
  const formattedDateTime = `${dayFormatted} ${monthAbbr} | ${year}`;

  return (
    <span>{formattedDateTime}</span>
  );
};

export default SimpleDateDisplay;